import type React from 'react'
import { resolvePenEditCursor } from '../helpers/pen-edit-cursor'
import type { PenHoverTarget } from '../types/node-edit-targets'

interface PenEditCaptureRectProps {
  bleedWidth: number
  bleedHeight: number
  penHover: PenHoverTarget
  penHoverRef: React.MutableRefObject<PenHoverTarget>
  onPenEditMove: (e: React.PointerEvent) => void
  onPenEditLeave: () => void
  onPenEditClick: (e: React.PointerEvent) => void
  onBackgroundDoubleClick?: () => void
}

/**
 * Pen-edit mode: transparent full-canvas overlay (rendered last so it captures events on top).
 * Pointer events outside the bleed area are handled by the window-level listeners in
 * hooks/use-pen-edit-mode.ts. A double-click with nothing hovered reports a background
 * double-click.
 */
export function PenEditCaptureRect({
  bleedWidth,
  bleedHeight,
  penHover,
  penHoverRef,
  onPenEditMove,
  onPenEditLeave,
  onPenEditClick,
  onBackgroundDoubleClick,
}: PenEditCaptureRectProps) {
  return (
    <rect
      x={0}
      y={0}
      width={bleedWidth}
      height={bleedHeight}
      fill="transparent"
      style={{
        pointerEvents: 'all',
        cursor: resolvePenEditCursor(penHover),
      }}
      onPointerMove={onPenEditMove}
      onPointerLeave={onPenEditLeave}
      onPointerDown={onPenEditClick}
      onDoubleClick={(e) => {
        if (penHoverRef.current) return
        e.preventDefault()
        e.stopPropagation()
        onBackgroundDoubleClick?.()
      }}
    />
  )
}
